import { render, staticRenderFns } from "./AnimationCard.vue?vue&type=template&id=2dc71fb5"
import script from "./AnimationCard.vue?vue&type=script&lang=ts"
export * from "./AnimationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports